// extracted by mini-css-extract-plugin
module.exports = {"row":"recently_viewed_section_row__2bk0_","col":"recently_viewed_section_col__9Xqfx"};